import React, {Component} from "react";
import {FeatureGroup, GeoJSON, LayerGroup} from "react-leaflet";
import {RoadSegment} from "../../../integration/representation/road-segment";
import {Geometry} from "geojson";
import * as WKTParser from "terraformer-wkt-parser";
import MapUtils from "../../map/map-utils";

class RoadSegments extends Component<any, {}> {
    private roads = React.createRef<LayerGroup>();
    private outlines = React.createRef<LayerGroup>();
    private selected = React.createRef<LayerGroup>();
    private unSelected = React.createRef<LayerGroup>();

    render() {
        const roadSegments: RoadSegment[] = this.props.roadSegments;
        const selectedRoadSegment: RoadSegment = this.props.selectedRoadSegment;
        const selectedSegments = roadSegments.filter(roadSegment => roadSegment.linkId === selectedRoadSegment?.linkId);
        const unSelectedSegments = roadSegments.filter(roadSegment => roadSegment.linkId !== selectedRoadSegment?.linkId);

        return (
            // @ts-ignore
            <FeatureGroup ref={this.roads}>

                <LayerGroup ref={this.unSelected}>
                    {unSelectedSegments.map(roadSegment => {
                        const key = `${roadSegment.linkId}-${roadSegment.linkPosFrom}-${roadSegment.linkPosTo}`;
                        const data = this.getMeteringCoordinates(roadSegment);
                        return (
                            <GeoJSON key={key}
                                     data={data}
                                     className={"roadsegment"}
                                     onClick={(e: React.MouseEvent) => this.handleRoadSegmentClick(e, roadSegment)}/>
                        );
                    })}
                </LayerGroup>

                <LayerGroup ref={this.outlines}>
                    {selectedSegments.map(roadSegment => {
                        const key = `${roadSegment.linkId}-${roadSegment.linkPosFrom}-${roadSegment.linkPosTo}`;
                        const data = this.getMeteringCoordinates(roadSegment);
                        return (
                            <GeoJSON key={key}
                                     data={data}
                                     className={"roadsegment outline"}
                                     onClick={(e: React.MouseEvent) => this.handleRoadSegmentClick(e, roadSegment)}/>
                        );
                    })}
                </LayerGroup>

                <LayerGroup ref={this.selected}>
                    {selectedSegments.map(roadSegment => {
                        const key = `${roadSegment.linkId}-${roadSegment.linkPosFrom}-${roadSegment.linkPosTo}`;
                        const data = this.getMeteringCoordinates(roadSegment);
                        const style = `roadsegment selected ${roadSegment.direction ? "animate" : ""}`;
                        return (
                            <GeoJSON key={key}
                                     data={data}
                                     className={style}
                                     onClick={(e: React.MouseEvent) => this.handleRoadSegmentClick(e, roadSegment)}/>
                        );
                    })}
                </LayerGroup>

            </FeatureGroup>
        );
    }

    componentDidUpdate() {
        this.pushLayersToBack(this.roads.current.leafletElement.getLayers());
        this.pushLayersToBack(this.outlines.current.leafletElement.getLayers());
    }

    pushLayersToBack(layers: any) {
        layers.forEach((layer: any) => {
            if (layer.bringToBack) layer.bringToBack();
            if (layer.getLayers) this.pushLayersToBack(layer.getLayers());
        });
    }

    handleRoadSegmentClick(e: React.MouseEvent, roadSegment: RoadSegment) {
        if (roadSegment.linkId !== this.props.selectedRoadSegment?.linkId) {
            this.props.doSetSelectedRoadSegment(roadSegment);
            if (!roadSegment.direction) {
                this.props.doDisplayMissingDirectionMessage("Den valgte vegstrekningen har ikke metreringsretning");
            }
        } else {
            this.props.doSetSelectedRoadSegment(null);
        }
    };

    getMeteringCoordinates(roadSegment: RoadSegment): Geometry {
        const geometryObjectUtm33 = WKTParser.parse(roadSegment.geometry);
        const geometryObjectWgs84 = MapUtils.convertUtm33ToWgs84(geometryObjectUtm33);

        switch (roadSegment.direction) {
            case undefined:
            case null:
            case "MED":
                return geometryObjectWgs84;
            case "MOT":
                return MapUtils.reverse(geometryObjectWgs84);
            default:
                throw "Direction of RoadSegment has to be 'MED' or 'MOT', but was " + roadSegment.direction;
        }
    }

}

export default RoadSegments;